// import maplibregl from 'maplibre-gl'
// import { FrameRateControl } from './fps'
import { Router } from './router';
import { ZoomControl } from './zoom';
import { TemporalControl } from './timeline';
import { isLocal } from '../common/conf';
var MapLibre = /** @class */ (function () {
    function MapLibre() {
        var _this = this;
        this.loadedPromise = new Promise(function (resolve) {
            return import(
            /* webpackChunkName: "maplibre-gl" */ 'maplibre-gl').then(function (maplibregl) {
                var map = (_this.map = new maplibregl.Map({
                    container: 'map',
                    style: (isLocal && false) ?
                        require('./style.json')
                        : 'https://api.maptiler.com/maps/67c96c26-a73f-427d-a51c-b7bc48b16a0a/style.json?key=0vS1h5DIiWbKBz0Cp88Q',
                    // style: 'http://95.179.156.178/api/maps/basic/style.json',
                    // style: 'http://95.179.156.178/api/maps/streets/style.json',
                    // style: 'https://api.maptiler.com/maps/67c96c26-a73f-427d-a51c-b7bc48b16a0a/style.json?key=0vS1h5DIiWbKBz0Cp88Q',
                    // style: 'https://api.maptiler.com/maps/winter/style.json?key=0vS1h5DIiWbKBz0Cp88Q',
                    // style: 'https://demotiles.maplibre.org/style.json',
                }));
                map.fitBounds([
                    new maplibregl.LngLat(72.456691, -5.5149093),
                    new maplibregl.LngLat(131.1652, 50.4278),
                ], { animate: false });
                _this.router = new Router(map);
                map.addControl(new maplibregl.NavigationControl({}));
                map.addControl(new ZoomControl(function () {
                    map.fitBounds([
                        new maplibregl.LngLat(72.456691, -5.5149093),
                        new maplibregl.LngLat(131.1652, 50.4278),
                    ], { animate: false });
                }));
                // var fpsControl: any = new FrameRateControl()
                // map.addControl(fpsControl, 'top-right')
                map.on('load', function () {
                    // map.setPaintProperty('water', 'fill-color', '#cccccc')
                    resolve(map);
                });
            });
        });
    }
    MapLibre.prototype.loaded = function () {
        return this.loadedPromise;
    };
    MapLibre.prototype.showTemporalControl = function (loader) {
        var control = new TemporalControl(loader);
        this.map.addControl(control);
        return control;
    };
    return MapLibre;
}());
export { MapLibre };
